import { fetchWidget } from './utilities/api/common';
import Api from './utilities/api/api';
import { trygTealium } from './utilities/tracking/trygTealium';

export default class Flow extends HTMLElement {
  static get observedAttributes() {
    return ['host', 'tenant', 'path', 'tealiumEnv'];
  }

  constructor() {
    super();
    this.tenant = '';
    this.host = '';
    this.path = '';
    this.tealiumEnv = '';
  }

  connectedCallback() {
    this.tenant = this.getAttribute('tenant') || this.getAttribute('clientid');
    this.host = this.getAttribute('host') || 'https://auto.widgets.tryg.dk';
    this.path = this.getAttribute('path') || this.getAttribute('flow');
    this.tealiumEnv = this.getAttribute('tealiumEnv');
    this.tracking = this.getAttribute('tracking') || 'false';
    this.trackingEnv = this.getAttribute('trackingEnv');
    this.shadowDom = this.getAttribute('shadowDom');
    this.partner = this.getAttribute('styleBase') || this.getAttribute('partner') || 'tryg';
    this.mountPoint = document.createElement('div');
    this.id = import.meta.env.VITE_WRAPPER_TAG;

    Api.setDefaultHost(this.host);
    fetchWidget(this.host, this.tenant, this.path).then((data) => {
      this.mountPoint.innerHTML = data;
      // tealiumEnv is retained to keep backward compatibility with existing embedded widgets
      if (this.isTealiumEnv() || this.isShadowDom()) {
        const styleHost = this.mountPoint.children[0].getAttribute('styleHost');
        const trygStyleElement = document.createElement('link');
        trygStyleElement.href = `${styleHost}/themes/custom/tryg/dist/css/styles-theme-${this.partner}.css`;
        trygStyleElement.rel = 'stylesheet';
        trygStyleElement.type = 'text/css';
        this.mountPoint.appendChild(trygStyleElement);
      }
    });

    let contentRoot = this;
    // tealiumEnv is retained to keep backward compatibility with existing embedded widgets
    if (this.isTealiumEnv() || this.isShadowDom()) {
      const shadowRoot = this.attachShadow({ mode: 'open' });
      contentRoot = shadowRoot;
    }
    if (this.isTealiumEnv() || this.isTrackingEnv() || this.isTracking()) {
      // Suppresses the automatic PAGE tracking event called by utag.js.
      window.utag_cfg_ovrd = { noview: true };
      trygTealium.initUtagData();
      trygTealium.checkCookieConsentsAccepted(this.tealiumEnv || this.trackingEnv || 'prod');
    }
    contentRoot.appendChild(this.mountPoint);
  }

  isTracking() {
    return this.tracking === 'true';
  }

  isTrackingEnv() {
    return this.trackingEnv && (this.trackingEnv === 'qa' || this.trackingEnv === 'prod');
  }

  isShadowDom() {
    return this.shadowDom !== 'false';
  }

  isTealiumEnv() {
    return this.tealiumEnv && (this.tealiumEnv === 'qa' || this.tealiumEnv === 'prod');
  }
}

const wrapperTag = import.meta.env.VITE_WRAPPER_TAG;
if (!window.customElements.get(wrapperTag)) {
  window.customElements.define(wrapperTag, Flow);
}
